// Reports Snake counters to the auth service.
//
// Snake is pure client-side canvas (no backend), so the browser is the
// only thing that can say a run was played. Same pattern as Flappy Bird /
// Brick Breaker / Sonic Jet: POST /api/beacon (the one unauthenticated write
// path, allowlisted in services/auth), fire-and-forget, never throws, never
// delays the game.

/** Same-origin: Caddy proxies /api to the auth service and leaves this path open. */
const ENDPOINT = '/api/beacon';
const GAME = 'snake';

function post(type: string, durationMs?: number): void {
  const payload: Record<string, unknown> = { game: GAME, type };
  if (durationMs !== undefined) {
    // Clamp to [1s, 6h] so a clock glitch or a tab left open for a day does
    // not write a nonsense duration. Schema allows up to 24h; 6h is still
    // generous for a single Snake run while keeping the dashboard sane.
    const clamped = Math.max(1000, Math.min(durationMs, 6 * 3600 * 1000));
    payload.durationMs = Math.round(clamped);
  }
  const body = JSON.stringify(payload);
  try {
    // sendBeacon survives the page being closed, which is exactly when a run
    // ends: the player crashes and shuts the tab. A fetch would be cancelled.
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'application/json' }));
      return;
    }
    void fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => {
      /* a lost counter is not worth surfacing to the player */
    });
  } catch {
    /* sendBeacon throws on some payload/permission combinations; ignore */
  }
}

export function reportPlay(): void {
  post('snake_play');
}

export function reportGameOver(durationMs: number): void {
  post('snake_game_over', durationMs);
}
